import React, {useEffect, useState, useRef} from "react";
import {motion, useAnimation} from "framer-motion";
import "./Snackbar.css";
import {isNotchedPhoneFromApple, useInterval} from "./utils";

let Snackbar = (props) => {
    let [vertical, setVertical] = useState('Snackbar--bottom');
    let [height, setHeight] = useState(0);
    let [y, setY] = useState(0);
    let anim = useAnimation();
    let [timer, setTimer] = useState(false);
    const ref = useRef(null)
    let [insets, setInsets] = useState({});

    useEffect(()=>{
        if (props.vertical === 'top') {
            setVertical('Snackbar--top');
        } else {
            setVertical('Snackbar--bottom');
        }
    }, [props.vertical]);

    useInterval(()=>{setHeight(ref.current.clientHeight)},100)

    useEffect(()=>{
        if (isNotchedPhoneFromApple()) {
            setInsets({marginTop:44,marginBottom:21});
        }

        if (props.start ===true) {
            anim.start({
                y: props.vertical === "bottom" ? window.innerHeight-height : 0
            });
            setTimer(()=>{
                setTimeout(()=>{
                    hideSnack();
                },props.duration)
            })
        }

        return ()=>{setTimer(false)}
    }, [props.start])

    let hideSnack = () => {
        anim.start({
            y: props.vertical === "bottom" ? window.innerHeight : -256
        });
        if (props.callback) {
            props.callback();
        }
    }

    return (
        <motion.div
            ref={ref}
            initial={{
                y: props.vertical === "bottom" ? window.innerHeight : -256
            }}
            animate={anim}
            onClick={()=>{hideSnack()}}
            id="snack"
            className={"Snackbar"+" "+vertical}
        >
            <div className="Snackbar--body" style={insets}>
                {props.children}
            </div>
        </motion.div>
    );
}
export default Snackbar;
